import { Release, useSetStableVersionMutation } from '../../gql/generated';
import { ModalContent } from '../manage-tags/ModalContent';
import { StyledModal } from '../StyledModal';

interface SetStableModalProps {
  release: Release;
  isVisible: boolean;
  onClose: () => void;
  refetch: () => void;
}

export const SetStableModal = (props: SetStableModalProps) => {
  const { release, isVisible, onClose, refetch } = props;
  const [setStableVersion, { loading, error }] = useSetStableVersionMutation();

  const handleClose = () => {
    refetch();
    onClose();
  };

  const onSetStableConfirm = async () => {
    if (!release || !release.id) {
      return;
    }
    await setStableVersion({
      variables: {
        input: {
          releaseId: release.id,
        },
      },
      onCompleted: () => {
        handleClose();
      },
    });
  };

  return (
    <StyledModal
      isOpen={isVisible}
      onRequestClose={handleClose}
      label="set-stable-modal"
      style={{
        content: {
          paddingTop: 30,
          paddingBottom: 30,
          paddingLeft: 20,
          paddingRight: 20,
          display: 'flex',
          flexDirection: 'column',
          minWidth: '52vw',
          position: undefined,
        },
        overlay: {
          backgroundColor: 'rgba(0,0,0,0.5)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: 999,
        },
      }}
    >
      <ModalContent
        title={`Set ${release?.semver} as Latest Approved`}
        loading={loading}
        error={error}
        handleSubmit={onSetStableConfirm}
        submitDisabled={loading}
        handleClose={handleClose}
        buttonLabels={{
          loading: 'Setting Stable Version...',
          create: 'Set Stable Version',
        }}
      ></ModalContent>
    </StyledModal>
  );
};
